/** Inline copy for the /join refusals (plan 476 M3). */
import type { JoinRequirementsResponse } from "./join-api";

export const INVALID_CAMPAIGN_CREDENTIAL_MESSAGE =
  "That campaign link is no longer valid. You can still sign up below.";
export const REQUIREMENTS_UNAVAILABLE_MESSAGE =
  "We couldn't check the signup requirements. Try again.";
export const POLICY_UNAVAILABLE_MESSAGE =
  "We couldn't check the signup options right now.";
export const CREDENTIAL_REQUIRED_MESSAGE =
  "Add your professional credential to continue.";
export const CONSUMER_ACCOUNT_EXISTS_MESSAGE =
  "This email already has a Sill buyer account. Use a different email for your pro account, or contact support.";

export const INVITATION_PENDING_MESSAGE =
  "You already have an invitation for this email. Use the link in it, or contact support.";

export const SERVICE_AREA_UNRESOLVABLE_MESSAGE =
  "Enter a city or ZIP we can find.";
export const GENERIC_JOIN_MESSAGE = "We couldn't finish signing you up. Try again.";

export interface JoinCredentialInput {
  licenseNumber: string;
  nmlsNumber: string;
}

/** Echoes the caller's own credential back so a conflict points at the right artifact. */
export function credentialConflictMessage(
  kind: JoinRequirementsResponse["credential_kind"] | undefined,
  input: JoinCredentialInput,
): string {
  if (kind === "nmls" && input.nmlsNumber.trim()) {
    return `The NMLS ID ${input.nmlsNumber.trim()} is already on another Sill account — each NMLS ID can back only one professional account. If it's yours, contact support.`;
  }
  if (kind === "re_license" && input.licenseNumber.trim()) {
    return `The license number ${input.licenseNumber.trim().toUpperCase()} is already on another Sill account — each license can back only one professional account. If it's yours, contact support.`;
  }
  return "This license is already associated with an account. Contact support.";
}

/** The sentence for a refusal code, or null when the server's own message should show. */
export function joinRejectMessage(
  code: string | undefined,
  kind: JoinRequirementsResponse["credential_kind"] | undefined,
  input: JoinCredentialInput,
): string | null {
  switch (code) {
    case "invalid_campaign_credential":
      return INVALID_CAMPAIGN_CREDENTIAL_MESSAGE;
    case "professional_credential_required":
      return CREDENTIAL_REQUIRED_MESSAGE;
    case "invalid_professional_credential":
      return kind === "nmls"
        ? "That NMLS ID doesn't look right. Enter 1–7 digits."
        : "That license number doesn't look right. Check it and try again.";
    case "professional_credential_conflict":
      return credentialConflictMessage(kind, input);
    case "service_area_unresolvable":
      return SERVICE_AREA_UNRESOLVABLE_MESSAGE;
    case "invitation_pending":
      return INVITATION_PENDING_MESSAGE;
    case "consumer_account_exists":
      return CONSUMER_ACCOUNT_EXISTS_MESSAGE;
    default:
      return null;
  }
}
